export default __webpack_public_path__ + "static/media/lt-flag.35da08ae.svg";